/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для страницы "Доставка товара"
   */
  app.InfoDeliveryPageView = app.View.extend({
    additionalOptions: ['currency'],
    /** @inheritDoc */
    run: function () {
      this.initChildViews();
    },

    /**
     * Инициализирует дочерние виды
     */
    initChildViews: function () {
      this.childViews.warehouseLinks = this.$('.warehouse-links .link').map(function () {
        return new app.DeliveryWhLinksView({
          el: $(this),
        });
      });
      this.childViews.tabsListView = new app.TabsListView();
      this.childViews.messageToManagerFormView = new app.MessageToManagerFormView();
      this.childViews.messageToCallMeFormContactGroupView = new app.MessageToCallMeFormContactGroupView();
      this.childViews.choiceCityDeliveryView = new app.ChoiceCityDeliveryView({
        settlement: this.settlement,
        $opener: this.$('.js-settlement-title'),
      });
      this.childViews.deliveryConditionView = new app.DeliveryConditionView({
        settlement: this.settlement,
        collection: new app.DeliveryTypes(),
        user: this.user,
        currency: this.currency,
      });
      this.$('.views').removeClass('not_display');
    },
  });
})(jQuery);

}.call(window));